import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FieldBase } from '@nagel-types';
import { DynamicFormFieldComponent } from '../dynamic-form-field/dynamic-form-field.component';
import { FieldControlService } from '../fieldControlService/field-control.service';
@Component({
    selector: 'app-dynamic-form',
    providers: [FieldControlService],
    imports: [ReactiveFormsModule, DynamicFormFieldComponent, MatProgressSpinner],
    templateUrl: './dynamic-form.component.html',
    styleUrl: './dynamic-form.component.scss'
})
export class DynamicFormComponent implements OnInit, OnChanges {
    @Input() fields: FieldBase<unknown>[] | null = [];
    @Input() formClassName = '';
    @Input() buttons?: FieldBase<unknown>[] | null = [];
    @Input() onChange?: (form: FormGroup, changes: SimpleChanges) => void;
    @Input() onSubmitHandler?: (form: FormGroup) => void;
    @Input() onResetHandler?: (form: FormGroup) => void;
    @Input() onInitHandler?: (form: FormGroup) => void;
    @Input() onValueChanges?: (values: unknown) => void;
    form!: FormGroup;
    payLoad = '';

    constructor(private fieldControlService: FieldControlService) { }

    ngOnInit() {
        this.form = new FormGroup(
            this.fieldControlService.mapInternalFields(
                this.fields as FieldBase<unknown>[],
                this.fieldControlService.getFormControl
            ) as { [x: string]: AbstractControl<unknown, unknown> }
        );
        this.onInitHandler && this.onInitHandler(this.form);

        if (this.onValueChanges) {
            this.form.valueChanges
                .subscribe(() => {
                    this.onValueChanges && this.onValueChanges(this.form.getRawValue());
                });
        }
    }

    onReset = () => {
        this.onResetHandler && this.onResetHandler(this.form);
    };

    ngOnChanges(changes: SimpleChanges) {
        if (this.form && this.onChange) {
            this.onChange(this.form, changes);
        }

        if (this.form && changes['fields'] && changes['fields'].currentValue) {
            this.fieldControlService.mapInternalFields(
                this.fields as FieldBase<unknown>[],
                this.fieldControlService.getFormControl
            );
        }
    }

    onSubmit = () => {
        this.onSubmitHandler && this.onSubmitHandler(this.form);
    };
}